import {
  DataLoadingWrapper,
  MultiSectionLayout,
} from "@jugl-web/ui-components";
import { ChatbotPreviewBackground } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/screens/WebChatBotAccountScreen/components/WebChatBotAppearanceTab/components/ChatbotPreviewBackground";
import React, { useState } from "react";
import { CRMChannel } from "@jugl-web/rest-api";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { InstagramTile } from "./components/InstagramTile";
import { TwilioTile } from "./components/TwilioTile";
import { WhatsappTile } from "./components/WhatsappTile";
import { WebChatTile } from "./components/WebChatTile";
import { WebChatPagePreview } from "./components/WebChatPagePreview";
import { GenericChannelPreview } from "./components/GenericChannelPreview";

export const PreviewAndInstallTabContent: React.FC<{ entityId: string }> = ({
  entityId,
}) => {
  const { isCRMConfigLoading, isCRMConfigError, refetchCRMConfig } =
    useManageAccountsDrawer();
  const [selectedChannel, setSelectedChannel] = useState<CRMChannel>(
    CRMChannel.chatbot
  );

  return (
    <DataLoadingWrapper
      isLoading={isCRMConfigLoading}
      isError={isCRMConfigError}
      onRetry={refetchCRMConfig}
    >
      <MultiSectionLayout
        leftSide={
          <div className="border-dark-200 jugl__custom-scrollbar flex h-full w-[464px] flex-col gap-7 overflow-y-auto border-0 border-r border-solid p-8">
            <WebChatTile
              isSelected={selectedChannel === CRMChannel.chatbot}
              onSelect={() => setSelectedChannel(CRMChannel.chatbot)}
            />
            <WhatsappTile
              isSelected={selectedChannel === CRMChannel.whatsapp}
              onSelect={() => setSelectedChannel(CRMChannel.whatsapp)}
            />
            <InstagramTile
              isSelected={selectedChannel === CRMChannel.instagram}
              onSelect={() => setSelectedChannel(CRMChannel.instagram)}
            />
            <TwilioTile
              isSelected={selectedChannel === CRMChannel.twilio}
              onSelect={() => setSelectedChannel(CRMChannel.twilio)}
            />
          </div>
        }
        className="animate-fade-in"
        classNames={{
          content: "flex items-center justify-center",
        }}
      >
        {selectedChannel !== CRMChannel.chatbot ? (
          <ChatbotPreviewBackground>
            <GenericChannelPreview
              channel={selectedChannel}
              entityId={entityId}
            />
          </ChatbotPreviewBackground>
        ) : (
          <WebChatPagePreview entityId={entityId} />
        )}
      </MultiSectionLayout>
    </DataLoadingWrapper>
  );
};
